import React, { useEffect, useState } from "react"

import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material"

import { toast } from "react-toastify"

import { CopyAllOutlined } from "@mui/icons-material"

import { QRCodeSVG } from "qrcode.react"
import ModalQRCode from "./ModalQRCode"

import AutocompleteCreatable from "../../components/AutoCompleteUTMSource"

import api from "../../services/api"

const ShareItem = ({ onCopy, value }) => (
    <Box display="flex" alignItems="center">
        <TextField
            fullWidth
            value={value}
            slotProps={{
                input: {
                    readOnly: true,
                    endAdornment: (
                        <IconButton onClick={onCopy}>
                            <CopyAllOutlined />
                        </IconButton>
                    ),
                },
            }}
        />
    </Box>
)

function ModalShare({ open, onClose, uuid }) {
    const [openModalQRCode, setOpenModalQRCode] = useState(false)
    const [selectedUtmSource, setSelectedUtmSource] = useState("")

    const [utms, setUtms] = useState([])

    const url = `${process.env.REACT_APP_FRONTEND_URL}/f/${uuid}`
    const [formatterUrl, setFortattedUrl] = useState(url)

    useEffect(() => {
        if (selectedUtmSource) {
            setFortattedUrl(`${url}?utm_source=${selectedUtmSource}`)
        } else {
            setFortattedUrl(`${url}`)
        }
    }, [selectedUtmSource, uuid])

    const handleCopyLink = async (link) => {
        try {
            await navigator.clipboard.writeText(link)
            toast.success("Link copiado!")
        } catch (error) {
            toast.error("Erro ao copiar link.")
        }
    }

    async function getUtmsSources() {
        try {
            const { data } = await api.get("/utm-sources")
            setUtms(data)
        } catch (error) {
            toast.error("erro ao buscar utms")
        }
    }

    useEffect(() => {
        getUtmsSources()
    }, [])

    const handleCreateNewUtmSource = async (newUtmSource) => {
        try {
            await api.post("/utm-sources", newUtmSource)
            setSelectedUtmSource(newUtmSource.key)
        } catch (error) {
            toast.error("Erro ao salvar nova UTM source")
        }
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Compartilhar Formulário</DialogTitle>
            <ModalQRCode
                open={openModalQRCode}
                handleClose={() => setOpenModalQRCode(false)}
                url={formatterUrl}
            />

            <DialogContent>
                <Stack width="100%" direction="column" spacing={2}>
                    <AutocompleteCreatable
                        options={utms}
                        handleSaveNewOption={(newOption) =>
                            handleCreateNewUtmSource(newOption)
                        }
                        onChange={(option) => setSelectedUtmSource(option.key)}
                    />

                    <ShareItem
                        onCopy={() => handleCopyLink(`${formatterUrl}`)}
                        value={`${formatterUrl}`}
                    />
                </Stack>

                <Box
                    marginTop={5}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Typography variant="body1" marginBottom={2}>
                        Baixar ou imprimir QR Code
                    </Typography>
                    <div
                        style={{
                            padding: 10,
                            backgroundColor: "white",
                        }}
                    >
                        <Tooltip title="Baixar QR Code">
                            <QRCodeSVG
                                onClick={() => setOpenModalQRCode(true)}
                                style={{
                                    cursor: "pointer",
                                }}
                                value={`${formatterUrl}`}
                                size={128}
                            />
                        </Tooltip>
                    </div>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModalShare
